<template>
  <router-view /> <!-- Aquí se cargarán las vistas de acuerdo con las rutas definidas -->
</template>

<script>
import { useSesion } from '@/composables/useSesion'
export default {
  name: 'App',
  created() {
    if (this.$route.path != '/') {
      const { iniciarVerificador } = useSesion()
      iniciarVerificador(10) // verifica cada 10 minutos
    }
  }
};
</script>

<style >
/* Aquí puedes agregar estilos globales si es necesario */
.page-background {
  background-image: url('@/assets/background.jpg'); /* Ruta de la imagen */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed; /* Mantiene el fondo fijo */
  min-height: 100vh; /* Altura completa de la ventana */
}
body, .v-application {
  text-transform: uppercase;
}
:root {
  --v-font-size-root: 8px;
}
.v-input {
  font-size: 12px;
}
.v-label {
  font-size: 10px !important;
}
</style>
